// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.

import React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import ConfigStartupSVG from "../Assets/images/svg/ConfigStartup.svg";
import { withTranslation } from "react-i18next";
import { ExternalLink } from "react-feather";

class TabConfig extends React.Component {
  render() {
    const { t } = this.props;

    microsoftTeams.settings.setValidityState(true);

    microsoftTeams.settings.registerOnSaveHandler((saveEvent) => {
      microsoftTeams.settings.setSettings({
        websiteUrl: process.env.REACT_APP_URI,
        contentUrl: process.env.REACT_APP_URI,
        entityId: process.env.REACT_APP_NAME,
        suggestedDisplayName: process.env.REACT_APP_NAME,
      });
      saveEvent.notifySuccess();
    });

    return (
      <div className="btsp">
        <div className="Karla container text-center">
          <img
            src={ConfigStartupSVG}
            alt="ACV StartUp | ACV - Tangible IT"
            width="62%"
          />
          <p>{t("configuration")[0]}</p>
          <a
            className="btn btn-sm btn-primary cur-pointer text-uppercase px-3"
            href="https://docs.acv.app/#acv-account"
            target="_blank"
          >
            <ExternalLink size={18} className="mr-2 mb-1" />
            {t("configuration")[1][1] ? (
              <>
                <span className="text-white-50">
                  {t("configuration")[1][0]}
                </span>{" "}
                {t("configuration")[1][1]}
              </>
            ) : (
              t("configuration")[1][0]
            )}
          </a>
          <a
            className="btn btn-sm btn-primary cur-pointer text-uppercase px-3"
            href="https://www.acv.app/demo"
            target="_blank"
          >
            <ExternalLink size={18} className="mr-2 mb-1" />
            <span className="text-white-50">
              {t("configuration")[2][0]}
            </span>{" "}
            {t("configuration")[2][1]}
          </a>
          <a
            className="btn btn-sm btn-primary cur-pointer text-uppercase px-3"
            href="https://www.acv.app/contact"
            target="_blank"
          >
            <ExternalLink size={18} className="mr-2 mb-1" />
            {t("configuration")[3]}
          </a>
        </div>
      </div>
    );
  }
}

export default withTranslation()(TabConfig);
